import Container from './DeviationTags.container';
import DeviationTags from './DeviationTags';

export default Container(DeviationTags);
